import React, { useEffect, useState } from 'react';
import LayoutWithNavbar from './LayoutWithNavbar';
import { FaEdit, FaPlus, FaTrash } from 'react-icons/fa';
import {
  fetchSupplierTypes,
  createSupplierType,
  updateSupplierType,
  deleteSupplierType
} from '../services/api';

const SupplierTypeMasterPage = () => {
  const [types, setTypes] = useState([]);
  const [loading, setLoading] = useState(false);
  const [modal, setModal] = useState({
    open: false,
    mode: 'add',
    data: { id: null, suppliertype: '', status: 'Active' }
  });

  const loadTypes = async () => {
    setLoading(true);
    const res = await fetchSupplierTypes();
    if (res.success) setTypes(res.data);
    else alert(res.message);
    setLoading(false);
  };

  useEffect(() => {
    loadTypes();
  }, []);

  const openModal = (mode, data = { id: null, suppliertype: '', status: 'Active' }) => {
    setModal({ open: true, mode, data });
  };

  const closeModal = () => {
    setModal({ open: false, mode: 'add', data: { id: null, suppliertype: '', status: 'Active' } });
  };

  const handleChange = (e) => {
    setModal({ ...modal, data: { ...modal.data, [e.target.name]: e.target.value } });
  };

  const handleSubmit = async () => {
    const { id, suppliertype, status } = modal.data;
    if (!suppliertype.trim()) return alert("Supplier type name is required.");

    const payload = { suppliertype: suppliertype.trim(), status };
    const res = modal.mode === 'edit'
      ? await updateSupplierType(id, payload)
      : await createSupplierType(payload);

    if (res.success) {
      alert(`Supplier Type ${modal.mode === 'edit' ? 'updated' : 'added'} successfully`);
      closeModal();
      loadTypes();
    } else {
      alert(res.message);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Are you sure you want to delete this supplier type?')) return;
    const res = await deleteSupplierType(id);
    if (res.success) {
      alert('Supplier type deleted successfully');
      loadTypes();
    } else {
      alert(res.message);
    }
  };

  return (
    <LayoutWithNavbar>
      <div style={styles.container}>
        <h2 style={styles.heading}>Supplier Type Master</h2>

        <div style={{ textAlign: 'right', marginBottom: '20px' }}>
          <button style={styles.addButton} onClick={() => openModal('add')}>
            <FaPlus style={{ marginRight: '6px' }} /> New Supplier Type
          </button>
        </div>

        {loading ? (
          <p>Loading...</p>
        ) : (
          <table style={styles.table}>
            <thead>
              <tr>
                <th style={styles.th}>Supplier Type</th>
                <th style={styles.th}>Status</th>
                <th style={styles.th}>Actions</th>
              </tr>
            </thead>
            <tbody>
              {types.map((type) => (
                <tr key={type.id}>
                  <td style={styles.td}>{type.suppliertype}</td>
                  <td style={styles.td}>{type.status}</td>
                  <td style={styles.td}>
                    <button style={styles.iconButton} onClick={() => openModal('edit', type)}><FaEdit /></button>
                    <button style={styles.deleteButton} onClick={() => handleDelete(type.id)}><FaTrash /></button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}

        {modal.open && (
          <div style={styles.modalBackdrop}>
            <div style={styles.modalBox}>
              <h4>{modal.mode === 'edit' ? 'Edit' : 'Add'} Supplier Type</h4>
              <input
                name="suppliertype"
                placeholder="Supplier Type"
                value={modal.data.suppliertype}
                onChange={handleChange}
                style={styles.input}
              />
              <select
                name="status"
                value={modal.data.status}
                onChange={handleChange}
                style={styles.input}
              >
                <option value="Active">Active</option>
                <option value="Inactive">Inactive</option>
              </select>
              <div style={{ marginTop: '20px' }}>
                <button style={styles.saveButton} onClick={handleSubmit}>Save</button>
                <button style={styles.cancelButton} onClick={closeModal}>Cancel</button>
              </div>
            </div>
          </div>
        )}
      </div>
    </LayoutWithNavbar>
  );
};

const styles = {
  container: { padding: '30px' },
  heading: { fontSize: '24px', fontWeight: '600', marginBottom: '20px' },
  addButton: { padding: '10px 16px', fontSize: '16px', backgroundColor: '#007bff', color: '#fff', border: 'none', borderRadius: '6px', cursor: 'pointer' },
  table: { width: '100%', borderCollapse: 'collapse', textAlign: 'center' },
  th: { padding: '12px', background: '#333', color: '#fff', fontWeight: '600', textAlign: 'center' },
  td: { padding: '10px', borderBottom: '1px solid #ddd', textAlign: 'center' },
  iconButton: { marginRight: '8px', padding: '6px 10px', backgroundColor: '#ffc107', color: '#000', border: 'none', borderRadius: '4px', cursor: 'pointer' },
  deleteButton: { padding: '6px 10px', backgroundColor: '#dc3545', color: '#fff', border: 'none', borderRadius: '4px', cursor: 'pointer' },
  modalBackdrop: { position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh', backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex', justifyContent: 'center', alignItems: 'center' },
  modalBox: { background: '#fff', padding: '30px', borderRadius: '10px', width: '400px', textAlign: 'center' },
  input: { width: '100%', padding: '10px', margin: '10px 0', fontSize: '16px', borderRadius: '6px', border: '1px solid #ccc' },
  saveButton: { padding: '10px 20px', backgroundColor: '#28a745', color: '#fff', border: 'none', borderRadius: '6px', cursor: 'pointer' },
  cancelButton: { padding: '10px 20px', backgroundColor: '#6c757d', color: '#fff', border: 'none', borderRadius: '6px', marginLeft: '10px', cursor: 'pointer' }
};

export default SupplierTypeMasterPage;
